import React, { Component } from 'react';
import imageButtonRestart from './img/btn10.png';
import imageResult from './img/text03.png';
import './view.css';

class ViewEnd extends Component {
    render() {
        return (
            <div className="container">
                <div className="alertimage" id="last">
                    <div className="window">
                        <div>
                            <img src={imageResult} id="howmany"></img>
                            <div className="buttons" onClick={this.props.onClickRestart}>
                                <img src={imageButtonRestart} id="restart"></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewEnd;
